import React from 'react';
import SvgIcon from './SvgIcon';

const ChatFull = props => {
    return (
        <SvgIcon viewBox="0 0 17 16" {...props}>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="map-tools" transform="translate(-1146.000000, -298.000000)" fill="#FFFFFF">
                    <g id="Group" transform="translate(1117.000000, 148.000000)">
                        <g id="CHATS" transform="translate(10.000000, 150.000000)">
                            <g id="chat" transform="translate(19.500000, 0.000000)">
                                <path
                                    d="M15.030303,3.55555556 C15.5655758,3.55555556 16,4.02014815 16,4.59259259 L16,4.59259259 L16,11.8518519 C16,12.4242963 15.5655758,12.8888889 15.030303,12.8888889 L15.030303,12.8888889 L13.0909091,12.8888889 L13.0909091,16 L10.1818182,12.8888889 L5.33333333,12.8888889 L7.10593939,10.8148148 L13.0909091,10.8148148 C13.6261818,10.8148148 14.0606061,10.3502222 14.0606061,9.77777778 L14.0606061,9.77777778 L14.0606061,3.55555556 Z M11.4074074,0 C11.9798519,0 12.4444444,0.464592593 12.4444444,1.03703704 L12.4444444,8.2962963 C12.4444444,8.86874074 11.9798519,9.33333333 11.4074074,9.33333333 L6.22222222,9.33333333 L3.11111111,12.4444444 L3.11111111,9.33333333 L1.03703704,9.33333333 C0.464592593,9.33333333 0,8.86874074 0,8.2962963 L0,1.03703704 C0,0.464592593 0.464592593,0 1.03703704,0 L11.4074074,0 Z"
                                    id="Path-2"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

ChatFull.displayName = 'ChatFullIcon';

export default ChatFull;
